import type {
  PackagingItem,
  PackagingItemPackagedItemLink,
} from '@/shared/hooks/api/packagingSuppliers'

export type SupplierPackagingCatalogRow = {
  id: string
  name: string
  sku: string | null
  skuInBomList?: boolean
  completedAt: string | null
  packagesOwnProduct: boolean
  linkedParts: PackagingItemPackagedItemLink[]
}

function toRow(item: PackagingItem): SupplierPackagingCatalogRow {
  return {
    id: item.id,
    name: item.name,
    sku: item.sku ?? null,
    skuInBomList: item.skuInBomList,
    completedAt: item.completedAt ?? null,
    packagesOwnProduct: item.packagesOwnProduct === false ? false : true,
    linkedParts: item.packagedItems ?? [],
  }
}

function sortRows(rows: SupplierPackagingCatalogRow[]): SupplierPackagingCatalogRow[] {
  return [...rows].sort((left, right) => {
    const leftPending = left.completedAt == null
    const rightPending = right.completedAt == null
    if (leftPending !== rightPending) {
      if (leftPending) {
        return -1
      }
      return 1
    }
    return left.name.localeCompare(right.name)
  })
}

export function mapSupplierPackagingCatalogRows(
  items: PackagingItem[]
): SupplierPackagingCatalogRow[] {
  return sortRows(items.map(toRow))
}
